import { forwardRef } from 'react';
import { type ColorlessIconProps, SVGContainer } from '@direct-frontend/components';

const IconSignalMiddle24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSignalMiddle24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M10.5 6C9.67157 6 9 6.67157 9 7.5V18C9 18.8284 9.67157 19.5 10.5 19.5H13.5C14.3284 19.5 15 18.8284 15 18V7.5C15 6.67157 14.3284 6 13.5 6H10.5Z"
                fill="currentColor"
            />
            <path
                d="M3 9C2.17157 9 1.5 9.67157 1.5 10.5V18C1.5 18.8284 2.17157 19.5 3 19.5H6C6.82843 19.5 7.5 18.8284 7.5 18V10.5C7.5 9.67157 6.82843 9 6 9H3Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 1.5C17.1716 1.5 16.5 2.17157 16.5 3V18C16.5 18.8284 17.1716 19.5 18 19.5H21C21.8284 19.5 22.5 18.8284 22.5 18V3C22.5 2.17157 21.8284 1.5 21 1.5H18Z"
                fill="currentColor"
                fillOpacity="0.5"
            />
        </SVGContainer>
    );
});

export const IconSignalMiddle = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSignalMiddle(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    return <IconSignalMiddle24 {...iconProps} />;
});
